import { ContractsI } from '../interfaces/contracts.interface'
import { ContractsService } from '../services/contracts.service'
import {
    AddTemplatePayload,
    ContractsAttachDocumentResponseT,
    ContractsDownloadContractResponseT,
    ContractsDownloadDocumentResponseT,
    ContractsExportExcelParamsT,
    ContractsGetContractByBinResponseT,
    ContractsGetContractResponseT,
    ContractsGetListResponseT,
    ContractsGetParamsT,
    ContractsGetServicesResponse,
    ContractsGetStatusesResponseT,
    ContractsGetToBeAgreedListResponseT,
    ContractsGetToBeAgreedParamsT,
    ContractsGetTypesParamsT,
    ContractsGetTypesResponseT,
    ContractsRegisterExportExcelParams,
    ContractsRegisterGetParams,
    ContractsRegisterGetResponse,
    ContractsSendTranscriptParamsT,
    ContractsShowContractResponseT,
    ContractsShowDocumentResponseT,
    CreateContractRegisterPayload,
    DownloadLogistBidResponse,
    EditContractRegisterPayload,
    GetConfigListParams,
    GetConfigListResponse,
    GetConfigValueByKeyResponse,
    GetContractRegisterResponse,
    GetTemplatesParams,
    GetTemplatesResponse,
} from '../types/contracts.types'

const contractsService = new ContractsService()

class ContractsRealisation implements ContractsI {
    getList(params: ContractsGetParamsT): Promise<ContractsGetListResponseT> {
        return contractsService.getList(params)
    }

    getServices(): Promise<ContractsGetServicesResponse> {
        return contractsService.getServices()
    }

    getTemplates(params: GetTemplatesParams): Promise<GetTemplatesResponse> {
        return contractsService.getTemplates(params)
    }

    getArchiveList(params: ContractsGetParamsT): Promise<ContractsGetListResponseT> {
        return contractsService.getArchiveList(params)
    }

    getRegisterList(params: ContractsRegisterGetParams): Promise<ContractsRegisterGetResponse> {
        return contractsService.getRegisterList(params)
    }

    getToBeAgreedList(
        params: ContractsGetToBeAgreedParamsT
    ): Promise<ContractsGetToBeAgreedListResponseT> {
        return contractsService.getToBeAgreedList(params)
    }

    getContract(contract_id: number): Promise<ContractsGetContractResponseT> {
        return contractsService.getContract(contract_id)
    }

    getContractRegister(id: number): Promise<GetContractRegisterResponse> {
        return contractsService.getContractRegister(id)
    }

    getContractByBin(bin: string): Promise<ContractsGetContractByBinResponseT> {
        return contractsService.getContractByBin(bin)
    }

    sendTranscript(payload: ContractsSendTranscriptParamsT): Promise<void> {
        return contractsService.sendTranscript(payload)
    }

    createContract(form_data: FormData): Promise<void> {
        return contractsService.createContract(form_data)
    }

    addCommentRegister(id: number, comment: string): Promise<void> {
        return contractsService.addCommentRegister(id, comment)
    }

    changeStatusRegister(id: number, statusId: number, comment?: string): Promise<void> {
        return contractsService.changeStatusRegister(id, statusId, comment)
    }

    createContractRegister(payload: CreateContractRegisterPayload): Promise<void> {
        return contractsService.createContractRegister(payload)
    }

    editContractRegister(id: number, payload: EditContractRegisterPayload): Promise<void> {
        return contractsService.editContractRegister(id, payload)
    }

    sendD24(form_data: FormData): Promise<void> {
        return contractsService.sendD24(form_data)
    }

    attachDocument(form_data: FormData): Promise<ContractsAttachDocumentResponseT> {
        return contractsService.attachDocument(form_data)
    }

    downloadContract(contract_id: number): Promise<ContractsDownloadContractResponseT> {
        return contractsService.downloadContract(contract_id)
    }

    showContract(contract_id: number): Promise<ContractsShowContractResponseT> {
        return contractsService.showContract(contract_id)
    }

    downloadDocument(document_id: number): Promise<ContractsDownloadDocumentResponseT> {
        return contractsService.downloadDocument(document_id)
    }

    showDocument(document_id: number): Promise<ContractsShowDocumentResponseT> {
        return contractsService.showDocument(document_id)
    }

    getTypes(params: ContractsGetTypesParamsT): Promise<ContractsGetTypesResponseT> {
        return contractsService.getTypes(params)
    }

    getStatuses(page: number): Promise<ContractsGetStatusesResponseT> {
        return contractsService.getStatuses(page)
    }

    getStatusesRegister(isVisible?: number): Promise<ContractsGetStatusesResponseT> {
        return contractsService.getStatusesRegister(isVisible)
    }

    exportExcel(params: ContractsExportExcelParamsT): Promise<any> {
        return contractsService.exportExcel(params)
    }

    exportExcelRegister(params: ContractsRegisterExportExcelParams): Promise<any> {
        return contractsService.exportExcelRegister(params)
    }

    downloadTranscript(transcript_id: number): Promise<any> {
        return contractsService.downloadTranscript(transcript_id)
    }

    updateContract(id: number, form_data: FormData): Promise<void> {
        return contractsService.updateContract(id, form_data)
    }

    addTemplate(form_data: FormData): Promise<void> {
        return contractsService.addTemplate(form_data)
    }

    deleteContract(contract_id: number): Promise<void> {
        return contractsService.deleteContract(contract_id)
    }

    deleteContractById(contract_id: number): Promise<void> {
        return contractsService.deleteContractById(contract_id)
    }

    deleteAdditionalContract(contract_id: number): Promise<void> {
        return contractsService.deleteAdditionalContract(contract_id)
    }

    checkIsSigned(id: number): Promise<void> {
        return contractsService.checkIsSigned(id)
    }

    deleteTemplate(id: number): Promise<void> {
        return contractsService.deleteTemplate(id)
    }

    editTemplate(id: number, form_data: FormData): Promise<void> {
        return contractsService.editTemplate(id, form_data)
    }

    downloadLogistBid(id: number): Promise<DownloadLogistBidResponse> {
        return contractsService.downloadLogistBid(id)
    }

    getConfigList(params: GetConfigListParams): Promise<GetConfigListResponse> {
        return contractsService.getConfigList(params)
    }

    getConfigValueByKey(key: string): Promise<GetConfigValueByKeyResponse> {
        return contractsService.getConfigValueByKey(key)
    }

    updateConfigKey(key: string, value: string[]): Promise<void> {
        return contractsService.updateConfigKey(key, value)
    }
}

export const contracts = new ContractsRealisation()
